var map = {
	"./type_arrowb.png": "b880",
	"./type_assassinb.png": "6275",
	"./type_fistb.png": "e1e3",
	"./type_healb.png": "d148",
	"./type_magicb.png": "729e",
	"./type_spearb.png": "e6fa",
	"./type_spilitb.png": "2293",
	"./type_swordb.png": "59f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "27f1";